import { Injectable } from '@angular/core';

import { ReportsAdvanceSettingsDataProvider } from '../../../reporting/providers/reports-advance-settings.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  AdvanceReportMetricColumnUpdate,
  LoadReportAdavceSettingConfig,
  LoadReportAdavceSettingConfigFailure,
  LoadReportAdavceSettingConfigSuccess,
  ReportAdavanceSettingActionTypes,
  SaveReportMetricConfiguration,
  SaveReportMetricConfigurationFailure,
  SaveReportMetricConfigurationSuccess,
  ValidateReportMetricConfig,
  ValidateReportMetricConfigFailure,
} from './adavance-setting.action';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ToastNotificationService } from '@monorepo/core-data';
import { ModalController } from '@ionic/angular';

@Injectable({ providedIn: 'root' })
export class AdvanceSettingEffects {
  constructor(
    private actions$: Actions,
    private reportsAdvanceSettingsDataProvider: ReportsAdvanceSettingsDataProvider,
    private notificationService: ToastNotificationService,
    private modalController: ModalController,
  ) {}

  loadReportAdavceSettingConfig$ = createEffect(() =>
    this.actions$.pipe(
      ofType<LoadReportAdavceSettingConfig>(ReportAdavanceSettingActionTypes.LoadReportAdavceSettingConfig),
      switchMap((action) => {
        return this.reportsAdvanceSettingsDataProvider.getMetricColumns(action.request).pipe(
          map((data) => {
            return new LoadReportAdavceSettingConfigSuccess(data);
          }),
          catchError((error) => {
            console.error('Failed to fetch the data', error);
            this.notificationService.showNofification({
              message: `Failed to fetch the data due: ${error.message}`,
              color: 'danger',
            });
            return of(new LoadReportAdavceSettingConfigFailure());
          }),
        );
      }),
    ),
  );

  saveReportMetricConfiguration$ = createEffect(() =>
    this.actions$.pipe(
      ofType<SaveReportMetricConfiguration>(ReportAdavanceSettingActionTypes.SaveReportMetricConfiguration),
      switchMap((action) => {
        return this.reportsAdvanceSettingsDataProvider.saveReportConfiguration(action.reportConfigSaveRequest).pipe(
          map((data) => {
            this.notificationService.showNofification({
              message: 'Successfully Saved',
              color: 'primary',
              duration: 3000,
            });
            return new SaveReportMetricConfigurationSuccess(data);
          }),
          catchError((errorObj) => {
            this.notificationService.showNofification({
              message: `Failed to save due to ${errorObj.error?.message}`,
              color: 'danger',
            });
            return of(new SaveReportMetricConfigurationFailure(errorObj));
          }),
        );
      }),
    ),
  );

  validateReportMetricConfig$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ValidateReportMetricConfig>(ReportAdavanceSettingActionTypes.ValidateReportMetricConfig),
      switchMap((action) => {
        return this.reportsAdvanceSettingsDataProvider
          .validateReportMetric(action.validateReportMetricConfig.request)
          .pipe(
            map((data) => {
              this.modalController.dismiss();
              this.notificationService.showNofification({
                message: 'Validation success',
                color: 'primary',
                duration: 3000,
              });
              return new AdvanceReportMetricColumnUpdate(action.validateReportMetricConfig.headerColumn);
            }),
            catchError((errorObj) => {
              console.error('Validation Failed', errorObj);
              this.notificationService.showNofification({
                message: `Validation failure due to ${errorObj.error?.message}`,
                color: 'danger',
              });
              return of(new ValidateReportMetricConfigFailure(errorObj.error));
            }),
          );
      }),
    ),
  );
}
